import { combineReducers } from "@reduxjs/toolkit";

import { dataAction, dataReducer, dataState } from "./data";
import { filtersAction, filtersReducer, filtersState } from "./filters";

export type StateReplenishments = {
	data: dataState;
	filters: filtersState;
};

export const replenishments = combineReducers<StateReplenishments>({
	data: dataReducer,
	filters: filtersReducer,
});

export const replenishmentsAction = {
	data: dataAction,
	filters: filtersAction,
};

export default replenishments;
